import "@styles/styles.scss";

import $ from "jquery";
import Minilog from "minilog";
import { PRODUCT_ELEMENT } from "@/constants/selectors";
import { initBlock1025 } from "./blocks/1025";
import { initBlock744 } from "@blocks/744";
import { initBlock750 } from "@/blocks/750";
import { initBlock754 } from "@blocks/754";
import { initBlock756 } from "@/blocks/756";
import { initBlock760 } from "@blocks/760";
import { initBlock762 } from "@blocks/762";
import { initBlock766 } from "@/blocks/766";
import { initBlock776 } from "@blocks/776";
import { initBlock778 } from "@blocks/778";
import { initBlock780 } from "@/blocks/780";
import { initBlock786 } from "@blocks/786";
import { initBlock922 } from "@blocks/922";
import { initBlock951 } from "@/blocks/951";
import { initGlobalSearch } from "@/blocks/initGlobalSearchResults";
import { initProductPage } from "@/blocks/product-page";
import { limitationsPromise } from "./hooks/useLimitation";
import { loadRatings } from "@/utils/loadRatings";

// eslint-disable-next-line new-cap
const logger = Minilog("global");
Minilog.enable();

// 2. Отправка запроса на получение данных и запись их в стейт
window.setTimeout(async () => {
  const limitations = await limitationsPromise;

  for (const limitation of limitations) {
    if (limitation.type === "reviews" && limitation.limit === 0) {
      console.log("CloudComments Plan Expired: Hide all widgets");
      return;
    }
  }

  loadRatings($(PRODUCT_ELEMENT), logger);

  const modalsEl = document.createElement("div");
  modalsEl.id = "CCModals";
  document.body.appendChild(modalsEl);

  // Single product blocks
  initBlock744();
  initBlock762();
  initBlock760();
  initBlock922();
  initBlock780();
  initGlobalSearch();

  // Catalog blocks
  initBlock754();
  initBlock776();
  initBlock778();
  initBlock786();
  initBlock951();
  initBlock1025();

  // Popups
  initBlock756();
  initBlock766();
  initBlock750();

  // Page
  initProductPage();
}, 1);

window.setTimeout(() => {
  window.dispatchEvent(new Event("resize"));
}, 1000);

// For dev
// window.logFn = function (fnName, cb) {
//   window.oldGetProductPopup = window[fnName];
//   window[fnName] = function (...rest) {
//     console.log(`[Logged] ${fnName} \n\n`, rest);
//     window.oldGetProductPopup(...rest);
//     cb && cb(rest);
//   };
// };

// logFn.bind(window, "t_store_changeUrl")();
// logFn.bind(window, "t_store_openProductPopup")();
